import http from '@/components/services/http-common';

const ROOT_URL = 'internalDenouces/';

export function fetchList(params) {
    return http.get(ROOT_URL + "hr", { params });
}

export function accept(code) {
    return http.get(ROOT_URL + 'changeStatus/' + code, {
        params: {
            status: 1
        }
    });
}

export function decline(code) {
    return http.get(ROOT_URL + 'changeStatus/' + code, {
        params: {
            status: 2
        }
    });
}

export function undo(code) {
    return http.get(ROOT_URL + 'changeStatus/' + code, {
        params: {
            status: 0
        }
    });
}

export function deleteItem(code) {
    return http.delete(ROOT_URL + code);
}
